// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.collection-inline {
    width: 100%;
}

div.collection-inline > .form-block-typed-collection-item > .inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

div.collection-inline > .form-block-typed-collection-item > .inner > div {
    width: 50%;
    padding: 0 15px;
}

.form-collection .selector {
    margin-bottom: 2rem;
}

.form-collection .selector input[type=number],
.form-collection .selector button {
    font-weight: 300;
    width: 50px;
    height: 50px;
    background-color: white;
    color: #464646;
    margin-right: 15px;
    border: 1px solid rgb(70, 70, 70);
    border-radius: 2px;
    opacity: 0.8;
    padding-top: 0;
    padding-bottom: 0;
    text-align: center;
}

.form-collection .selector input[type=number].selected,
.form-collection .selector button.selected {
    color: white;
    border: 1px solid rgb(36, 146, 223);
    border-radius: 2px;
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.2);
    background: rgba(36,143,223,1);
    background: linear-gradient(135deg, rgba(36,143,223,1) 37%, rgba(37,175,227,1) 59%, rgba(40,234,234,1) 100%);
}

div.grid-layout-collection-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

div.grid-layout-collection-items .form-block-typed-collection-item {
    max-width: 49%;
}

div.grid-layout-collection .form-field-error {
    margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/form/Collection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,2CAA2C;IAC3C,8BAA8B;IAC9B,4GAA4G;AAChH;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["div.collection-inline {\n    width: 100%;\n}\n\ndiv.collection-inline > .form-block-typed-collection-item > .inner {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\ndiv.collection-inline > .form-block-typed-collection-item > .inner > div {\n    width: 50%;\n    padding: 0 15px;\n}\n\n.form-collection .selector {\n    margin-bottom: 2rem;\n}\n\n.form-collection .selector input[type=number],\n.form-collection .selector button {\n    font-weight: 300;\n    width: 50px;\n    height: 50px;\n    background-color: white;\n    color: #464646;\n    margin-right: 15px;\n    border: 1px solid rgb(70, 70, 70);\n    border-radius: 2px;\n    opacity: 0.8;\n    padding-top: 0;\n    padding-bottom: 0;\n    text-align: center;\n}\n\n.form-collection .selector input[type=number].selected,\n.form-collection .selector button.selected {\n    color: white;\n    border: 1px solid rgb(36, 146, 223);\n    border-radius: 2px;\n    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.2);\n    background: rgba(36,143,223,1);\n    background: linear-gradient(135deg, rgba(36,143,223,1) 37%, rgba(37,175,227,1) 59%, rgba(40,234,234,1) 100%);\n}\n\ndiv.grid-layout-collection-items {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\ndiv.grid-layout-collection-items .form-block-typed-collection-item {\n    max-width: 49%;\n}\n\ndiv.grid-layout-collection .form-field-error {\n    margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
